import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  GameResultTimeTextField,
  GameTaskTextField,
  GameTitleTextField,
} from "./TextFields";
import { ScreenCompletedCheckbox } from "./Checkboxes";
import Music from "./music";
import ScreenBackgroundColorPicker from "./screen-background-color-picker";

import { AppDispatch } from "store/store";
import { Screen } from "models";

import { getFileById } from "actions/file-actions-typed";
import { GAME_SCREEN_DEFAULT_RESULT_TIME } from "constants/screen";

// - -

type GameDescriptionProps = {
  activeScreen: Screen;
  taskHelpIconLabel: string;
};

const GameDescription = ({
  activeScreen,
  taskHelpIconLabel,
}: GameDescriptionProps) => {
  const { t } = useTranslation("expo-editor");
  const dispatch = useDispatch<AppDispatch>();

  const musicFile =
    "music" in activeScreen ? dispatch(getFileById(activeScreen.music)) : null;

  return (
    <div className="container container-tabMenu">
      <div className="screen">
        <div className="description-container">
          <div className="part margin-bottom margin-horizontal">
            <GameTitleTextField gameTitleValue={activeScreen.title ?? ""} />
            <GameTaskTextField
              taskValue={
                "task" in activeScreen && activeScreen.task
                  ? activeScreen.task
                  : ""
              }
              taskHelpIconLabel={taskHelpIconLabel}
            />
          </div>

          <div className="part margin-bottom margin-horizontal">
            <GameResultTimeTextField
              resultTimeValue={
                "resultTime" in activeScreen
                  ? activeScreen.resultTime ?? GAME_SCREEN_DEFAULT_RESULT_TIME
                  : GAME_SCREEN_DEFAULT_RESULT_TIME
              }
            />

            <Music
              aloneScreen={
                "aloneScreen" in activeScreen
                  ? !!activeScreen.aloneScreen
                  : false
              }
              muteChapterMusic={
                "muteChapterMusic" in activeScreen
                  ? !!activeScreen.muteChapterMusic
                  : false
              }
              musicFile={musicFile}
              helpIconTitle={t("descFields.musicDescriptionHelpTooltip")}
              id="editor-game-description-music"
            />

            <ScreenCompletedCheckbox
              screenCompletedValue={
                "screenCompleted" in activeScreen
                  ? !!activeScreen.screenCompleted
                  : false
              }
            />

            <ScreenBackgroundColorPicker
              label={t("descFields.screenBackgroundColorLabel")}
              helpText={t("descFields.screenBackgroundColorTooltip")}
              color={
                "screenBgColor" in activeScreen && !!activeScreen.screenBgColor
                  ? activeScreen.screenBgColor
                  : null
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameDescription;
